module.exports = __webpack_public_path__ + "static/media/BOEHRINGERLOGO.1c2af8d7.png";